export const opacity = {
    0.2: '0.2',
    0.5: '0.5',
    0.8: '0.8',
    1: '1',
};
